<template>
    <v-layout row wrap>
        <v-flex xs12 md6>
          <v-menu v-model="dateFromMenu" :close-on-content-click="false" full-width max-width="280">
            <v-text-field
              slot="activator"
              :value="computeDateFrom"
              clearable
              label="Date From"
              readonly
            ></v-text-field>
            <v-date-picker v-model="dateFromString" @change="dateFromMenu = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md6>
          <v-menu v-model="dateToMenu" :close-on-content-click="false" full-width max-width="280">
            <v-text-field
              slot="activator"
              :value="computeDateTo"
              clearable
              label="Date To"
              readonly
            ></v-text-field>
            <v-date-picker v-model="dateToString" @change="dateToMenu = false"></v-date-picker>
          </v-menu>
        </v-flex>
    </v-layout>
</template>

<script>
import moment from 'moment'
export default {
  name: 'SelectDates',
  props: {
    days: { type: Number, default: 1 }
  },
  data: () => ({
    dateFromMenu: false,
    dateToMenu: false,
    dateFromString: '',
    dateToString: ''

  }),
  computed: {
    computeDateFrom () {
      this.setParentFromDate()
      return this.dateFromString
        ? moment(this.dateFromString).format('dddd, MMMM Do YYYY')
        : ''
    },
    computeDateTo () {
      this.setParentToDate()
      return this.dateToString
        ? moment(this.dateToString).format('dddd, MMMM Do YYYY')
        : ''
    }
  },
  methods: {
    setParentToDate () {
      this.$emit('updateDates', this.dateToString, this.dateFromString)
    },
    setParentFromDate () {
      this.$emit('updateDates', this.dateToString, this.dateFromString)
    }
  },
  beforeMount () {
    // Set initial date values.
    var today = new Date()
    this.dateToString = today.toISOString().substr(0, 10)
    today.setDate(today.getDate() - this.days)
    this.dateFromString = today.toISOString().substr(0, 10)
  }
}
</script>
